import React, { useContext } from 'react'
// @ts-ignore
import { Progress } from 'react-sweet-progress'
import 'react-sweet-progress/lib/style.css'
import { Button, Flex, Heading, Text } from 'rebass'
import { trackHandler, UneeqContext, useTimeout } from 'uneeq-react-core'
import { Overlay } from 'uneeq-react-ui'
import styles from './styles'
import { useTheme } from 'emotion-theming'
import { useTranslation } from 'react-i18next'
import { MayaOverlay } from '../MayaOverlay'

const MayaTimeout = ({ endSession }: any) => {
  const theme: any = useTheme()
  const {
    config: { timeoutWarning }
  } = useContext(UneeqContext)
  const { timeoutOpen, timeLeft, resetTimeout } = useTimeout()
  const { t } = useTranslation()

  if (!timeoutOpen) return null

  const seconds = Math.max(Math.ceil(timeLeft / 1000), 0)
  const progress = (timeLeft / timeoutWarning) * 100

  return (
    <MayaOverlay>
      <Flex sx={styles.container}>
        <Heading sx={styles.heading}>{t('Timeout.heading')}</Heading>
        <Text sx={styles.text}>{t('Timeout.subtitle')}</Text>
        <Flex sx={styles.progress}>
          <Text sx={styles.time}>{seconds}s</Text>
          <Progress
            percent={progress}
            theme={{
              active: {
                trailColor: theme.colors.timeoutColor,
                color: theme.colors.timeoutTrailColor
              }
            }}
          />
        </Flex>
        <Flex sx={styles.buttonsContainer}>
          <Button
            variant="whiteInverted"
            sx={styles.leaveChatButton}
            onClick={trackHandler(endSession, 'timeout-finished-btn')}
          >
            {t('Timeout.leaveChat')}
          </Button>
          <Button
            variant="primary"
            sx={styles.backToChatButton}
            onClick={trackHandler(resetTimeout, 'timeout-continue-session-btn')}
          >
            {t('Timeout.backToChat')}
          </Button>
        </Flex>
      </Flex>
    </MayaOverlay>
  )
}

export default MayaTimeout
